import { render, staticRenderFns } from "./ExtendedCalendar.vue?vue&type=template&id=120af428&scoped=true&"
import script from "./ExtendedCalendar.vue?vue&type=script&lang=js&"
export * from "./ExtendedCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedCalendar.vue?vue&type=style&index=0&id=120af428&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120af428",
  null
  
)

export default component.exports